// The type of line should be [number, number][] but this confuses the non-strict compiler
export function getLineMidPoint(
    line: [lon: number, lat: number, ...unknown[]][] | undefined,
): [lon: number, lat: number] | undefined {
    if (!line || line.length < 2) {
        return undefined;
    }
    if (line.length % 2 == 0) {
        const midIndexLower = line.length / 2 - 1;
        const midIndexUpper = line.length / 2;
        return [
            (line[midIndexLower][0] + line[midIndexUpper][0]) / 2,
            (line[midIndexLower][1] + line[midIndexUpper][1]) / 2,
        ];
    } else {
        const midIndex = Math.floor(line.length / 2);
        return [line[midIndex][0], line[midIndex][1]];
    }
}
